import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "db-table"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rating = _resolveComponent("rating");
  const _component_empty_chart = _resolveComponent("empty-chart");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params, (param, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle({
        width: param.width,
        minWidth: param.width
      }),
      class: "th"
    }, _toDisplayString(param.column), 5);
  }), 128))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTable, (line, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "tr border_bottom"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params, (param, idx) => {
      return _openBlock(), _createElementBlock("div", {
        key: idx,
        style: _normalizeStyle({
          width: param.width,
          minWidth: param.width
        }),
        class: "td"
      }, [param.key === 'note' ? (_openBlock(), _createBlock(_component_rating, {
        key: 0,
        value: line[param.key],
        class: "rating"
      }, null, 8, ["value"])) : _createCommentVNode("", true), param.key !== 'note' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([{
          blue: idx === 2
        }, "ellipsis"])
      }, _toDisplayString(idx === 0 ? index + 1 + ". " + line[param.key] : line[param.key]), 3)) : _createCommentVNode("", true)], 4);
    }), 128))]);
  }), 128))])])], 512), [[_vShow, _ctx.dataTable?.length]]), _withDirectives(_createVNode(_component_empty_chart, {
    loading: _ctx.loading,
    url: _ctx.big ? '/public/images/charts/List-Large.png' : '/public/images/charts/List-Small.png'
  }, null, 8, ["loading", "url"]), [[_vShow, !_ctx.dataTable?.length]])]);
}